export const TICK_RATE = 60;
export const TICK_DT = 1 / TICK_RATE;
export const SNAPSHOT_RATE = 20;
export const SNAPSHOT_EVERY = TICK_RATE / SNAPSHOT_RATE; // ticks between snapshots
export const INPUT_SEND_RATE = 30;

export const MAX_PLAYERS_DEFAULT = 8;
export const MAX_SPEED_ABS = 150; // hard ceiling m/s

export const COUNTDOWN_TICKS = TICK_RATE * 4; // 3..2..1..GO
export const RESULTS_LINGER_TICKS = TICK_RATE * 30; // auto-return to lobby
export const FINISH_TIMEOUT_TICKS = TICK_RATE * 45; // after first finisher, others get 45s

export const PROTOCOL_VERSION = 3;
export const GHOST_VERSION = 2;
export const SAVE_VERSION = 2;

export const DEFAULT_PORT = 8734;
